<template>
	<div v-loading.fullscreen.lock="loading" class="postJob">
		<div class="postJobCon">
			<div class="head">
				<div class="title">
					{{id?'编辑职位':'发布新职位'}} 
				</div>
				<div class="tips" v-if="status==0||status==1">编辑将会触发平台审核，平台审核通过后修改生效</div>
			</div>
			<div class="fill">

				<div class="form">
					<el-form :model="ruleForm" ref="ruleForm" :rules="rules" label-width="100px" label-position='top'>
						<div class="title">
							<!-- <img src="@/static/sort.png" class="icon" /> -->
							<div>
								填写职位信息
							</div>
						</div>
						
						<div class="flexbox">
							<el-form-item label="职位名称" prop="position_name">
								<el-input v-model="ruleForm.position_name" placeholder="职位名称"
									style="width: 300px;"></el-input>
							</el-form-item>
							<el-form-item label="招聘类型" prop="type">
								<el-radio-group v-model="ruleForm.type" placeholder="请选择职位类型" style="width: 300px;">
									<!-- <el-radio v-for="(item,index) of workList" :key="index"
										:label="item.value">{{item.label}}</el-radio> -->
									<el-radio label="0">社招</el-radio>
									<el-radio label="1">实习生招聘</el-radio>
									<el-radio label="2">兼职招聘</el-radio>
								</el-radio-group>
							</el-form-item>
							<el-form-item label="职位分类" prop="position_type_id">
								<el-cascader :options="classList" :props="classProps" :show-all-levels="false"
									v-model="ruleForm.position_type_id" style="width: 300px;"></el-cascader>
							</el-form-item>
						</div>
						
						<template v-if="ruleForm.type==2">
							<div class="flexbox">
								<el-form-item v-if="ruleForm.type==2" label="兼职类型" prop="part_time_job_type">
									<el-input v-model="ruleForm.part_time_job_type" placeholder="兼职类型"
										style="width: 300px;"></el-input>
								</el-form-item>
								<el-form-item v-if="ruleForm.type==2" label="兼职工资" prop="salary_part_time_job">
									<el-input v-model="ruleForm.salary_part_time_job" placeholder="兼职工资"
										style="width: 300px;"></el-input>
								</el-form-item>
								<el-form-item label="经验要求" prop="tag_name_year">
									<el-select v-model="ruleForm.tag_name_year" placeholder="请选择" style="width: 300px;">
										<el-option v-for="(item,index) of expList" :key="index" :label="item"
											:value="item"></el-option>
									</el-select>
								</el-form-item>
							</div>
							
							<div class="flexbox">
								<el-form-item label="最低学历" prop="tag_name_qualifications">
									<el-select v-model="ruleForm.tag_name_qualifications" placeholder="请选择" style="width: 300px;">
										<el-option v-for="(item,index) of eduList" :key="index" :label="item" :value="item"></el-option>
									</el-select>
								</el-form-item>
								<el-form-item label="工作时间" prop="work_time">
									<el-input v-model="ruleForm.work_time" placeholder="工作时间" style="width: 300px;"></el-input>
								</el-form-item>
								<el-form-item label="结算方式" prop="salary_type">
									<el-select v-model="ruleForm.salary_type" placeholder="请选择" style="width: 300px;">
										<el-option v-for="(item,index) of settleList" :key="index" :label="item"
											:value="item"></el-option>
									</el-select>
								</el-form-item>
							</div>
							
							<div class="flexbox">
								<el-form-item label="行业" prop="industry_id">
									<el-select v-model="ruleForm.industry_id" placeholder="请选择" style="width: 300px;">
										<el-option v-for="(item,index) of industryList" :key="index" :label="item.industry_name"
											:value="item.id"></el-option>
									</el-select>
								</el-form-item>
								<el-form-item label="福利标签" prop="tag_name_others">
									<div class="label">
										<el-input v-model="tagValue" style="width: 220px;margin-right: 10px;"></el-input>
										<el-button type="primary" @click="addTga()">添加</el-button>
									</div>
									<div class="tags">
										<el-tag v-for="(item,index) of ruleForm.tag_name_others" :key="index" closable
											class="tagsLi" @close='clearTga(index)'>
											{{item}}
										</el-tag>
									</div>
								</el-form-item>
							</div>
						</template>
						
						<template v-else>
							<div class="flexbox">
								<el-form-item label="经验要求" prop="tag_name_year">
									<el-select v-model="ruleForm.tag_name_year" placeholder="请选择" style="width: 300px;">
										<el-option v-for="(item,index) of expList" :key="index" :label="item"
											:value="item"></el-option>
									</el-select>
								</el-form-item>
								<el-form-item label="学历要求" prop="tag_name_qualifications">
									<el-select v-model="ruleForm.tag_name_qualifications" placeholder="请选择" style="width: 300px;">
										<el-option v-for="(item,index) of eduList" :key="index" :label="item" :value="item"></el-option>
									</el-select>
								</el-form-item>
								<div class="flexbox">
									<el-form-item v-if="ruleForm.type!=2" label="最低薪资" prop='salary_min' style="margin-right: 0;">
										<el-select v-model="ruleForm.salary_min" placeholder="最低薪资" style="width: 140px;"
											@change="handleMinSalaryChange">
											<el-option v-for="minSalary in minArray" :key="minSalary.value" :label="minSalary.label"
												:value="minSalary.value"></el-option>
										</el-select>
										<span style="margin: 0 8px;">-</span>
									</el-form-item>
									<el-form-item v-if="ruleForm.type!=2" label="最高薪资" prop='salary_max' >
										<el-select v-model="ruleForm.salary_max" placeholder="最高薪资" style="width: 140px;">
											<el-option v-for="maxSalary in availableMaxSalaries" :key="maxSalary.value"
												:label="maxSalary.label" :value="maxSalary.value"></el-option>
										</el-select>
									</el-form-item>
								</div>
							</div>
							
							<div class="flexbox">
								<el-form-item label="工作时间" prop="work_time">
									<el-input v-model="ruleForm.work_time" placeholder="工作时间" style="width: 300px;"></el-input>
								</el-form-item>
								
								<el-form-item label="结算方式" prop="salary_type">
									<el-select v-model="ruleForm.salary_type" placeholder="请选择" style="width: 300px;">
										<el-option v-for="(item,index) of settleList" :key="index" :label="item"
											:value="item"></el-option>
									</el-select>
								</el-form-item>
								<el-form-item label="行业" prop="industry_id">
									<el-select v-model="ruleForm.industry_id" filterable placeholder="请选择" style="width: 300px;">
										<el-option v-for="(item,index) of industryList" :key="index" :label="item.industry_name"
											:value="item.id"></el-option>
									</el-select>
								</el-form-item>
							</div>
							
							
							
							<el-form-item label="福利标签" prop="tag_name_others">
								<div class="label">
									<el-input v-model="tagValue" style="width: 220px;margin-right: 10px;"></el-input>
									<el-button type="primary" @click="addTga()">添加</el-button>
								</div>
								<div class="tags" style="width: 300px;">
									<el-tag v-for="(item,index) of ruleForm.tag_name_others" :key="index" closable
										class="tagsLi" @close='clearTga(index)'>
										{{item}}
									</el-tag>
								</div>
							</el-form-item>
						</template>
						

						<el-form-item label="工作地点" prop="address">
							<chooseLocation :width="740" :location="location" @pickAddress="pickAddress($event)"></chooseLocation>
						</el-form-item>
						
						<el-form-item label="政策福利" prop="position_welfare_policy">
							<el-input type="textarea" class="textarea" :autosize="{ minRows: 8, maxRows: 16}"
								placeholder="政策福利" v-model="ruleForm.position_welfare_policy"
								style="width: 740px;"></el-input>
						</el-form-item>
						
						<el-form-item label="工作职责" prop="job_responsibilities">
							<el-input type="textarea" class="textarea" :autosize="{ minRows: 8, maxRows: 16}"
								placeholder="介绍工作职责" v-model="ruleForm.job_responsibilities" style="width: 740px;"></el-input>
						</el-form-item>

						<el-form-item label="职位要求" prop="position_requirement">
							<el-input type="textarea" class="textarea" :autosize="{ minRows: 8, maxRows: 16}"
								placeholder="介绍职位要求" v-model="ruleForm.position_requirement" style="width: 740px;"></el-input>
						</el-form-item>
						
						<el-form-item label="职位描述" prop="position_description">
							<el-input type="textarea" class="textarea" :autosize="{ minRows: 8, maxRows: 16}"
								placeholder="介绍工作内容" v-model="ruleForm.position_description" style="width: 740px;"></el-input>
						</el-form-item>


					</el-form>
				</div>

				<div class="buttonG">
					<!-- <el-button v-if="id" type="primary" plain @click="remove()">删除</el-button> -->
					<el-button type="primary" plain @click="backGo()">关闭</el-button>
					<el-button v-if="status!='0'&&status!='1'" type="primary" plain @click="save(2)">保存至草稿</el-button>
					<el-button type="primary" class="save" @click="save(1)">{{id?'保存编辑':'发布职位'}}</el-button>
				</div>

			</div>


		</div>
	</div>
</template>

<script>
	import { eduList, expList, minArray, maxArray } from '@/unit/disposition.js';
	export default {
		name: 'postJob',
		data() {
			return {
				ruleForm: {
					position_name: '',
					type: '0',
					position_type_id: '',
					part_time_job_type: '',
					salary_part_time_job: '',
					tag_name_year: '',
					tag_name_qualifications: '',
					tag_name_others: [],
					salary_type: '',
					salary_min: '',
					salary_max: '',
					position_welfare_policy: '',
					work_time: '',
					job_responsibilities: '',
					position_requirement: '',
					position_description: '',
					position_tips: '',
					address: '',
					address_code: '',
					contact_person: '',
					contact_phone: '',
					lng: '',
					lat: '',
					industry_id: '',
					address_details: '',
				},
				rules:{
					position_name: [{ required: true, message: '请输入职位标题', trigger: 'blur' }],
					position_id: [{ required: true, message: '请选择职位分类', trigger: 'change' }],
					part_time_job_type: [{ required: true, message: '请输入兼职类型', trigger: 'blur' }],
					salary_part_time_job: [{ required: true, message: '请输入兼职薪资', trigger: 'blur' }],
					tag_name_year: [{ required: true, message: '请选择经验要求', trigger: 'change' }],
					tag_name_qualifications: [{ required: true, message: '请选择最低学历', trigger: 'change' }],
					salary_type: [{ required: true, message: '请选择结算方式', trigger: 'change' }],
					salary_max:[{ required: true, message: '请选择最高薪资', trigger: 'change' }],
					salary_min:[{ required: true, message: '请选择最低薪资', trigger: 'change' }],
					work_time:[{ required: true, message: '请选择工作时间', trigger: 'change' }],
					job_responsibilities:[{ required: true, message: '请输入岗位职责', trigger: 'blur' }],
					position_requirement:[{ required: true, message: '请输入职位要求', trigger: 'blur' }],
					position_description:[{ required: true, message: '请输入职位描述', trigger: 'blur' }],
					position_welfare_policy:[{ required: true, message: '请输入福利政策', trigger: 'blur' }],
					industry_id:[{ required: true, message: '请选择行业', trigger: 'blur' }],
					address:[{ required: true, message: '请选择工作地点', trigger: 'blur' }],
				},
				eduList,
				expList,
				tagValue: '',
				settleList: ['日结', '周结', '半月结', '月结', '项目结'],
				cityList: [],
				classList: [],
				classProps: {
					value: 'id',
					label: 'type_name',
					children: 'child',
					emitPath: false
				},
				industryList: [], //行业列表
				minArray: minArray,
				maxArray: maxArray,
				id:'',
				mouseTool: null,
				overlays: [],
				auto: null,
				placeSearch: null,
				loading:false,
				status:'',
				location:''
			}
		},
		computed: {
			availableMaxSalaries() {
				// 在最高薪资选项中剔除低于最低薪资的选项
				if (this.ruleForm.salary_min) {
					return this.maxArray.filter((salary) => salary.value > this.ruleForm.salary_min);
				} else {
					return this.maxArray;
				}
			},
		},
		created() {
			this.getIndustry()
			this.getClass()
		},
		mounted() {
			if(this.$route.query.id){
				this.id=this.$route.query.id
				this.getDetail()
			}
		},
		methods: {
			pickAddress (e){
				this.ruleForm.address = e.pname+'-'+e.cityname+'-'+e.adname
				this.ruleForm.address_details = e.name
				this.ruleForm.lat = e.location.lat
				this.ruleForm.lng = e.location.lng
			},
			handleMinSalaryChange() {
				// 处理最低薪资变化
				if (this.ruleForm.salary_max && this.ruleForm.salary_min > this.ruleForm.salary_max) {
					this.ruleForm.salary_max = null;
				}
			},
			addTga() {
				if (this.tagValue) {
					this.ruleForm.tag_name_others.push(this.tagValue)
					this.tagValue = ''
				}
			},
			clearTga(index) {
				this.ruleForm.tag_name_others.splice(index, 1)
			},
			getIndustry() {
				this.$axios.get('/api/client/Common/getIndustrys').then(res => {
					this.industryList = res.data
				})
			},
			getClass() {
				this.$axios.get('/api/client/Common/getPositionType').then(res => {
					this.classList = res.data
				})
			},
			backGo(){
				this.$router.go(-1)
			},
			// 获取职位详情
			getDetail(){
				this.loading = true
				this.$axios.get('/api/client/ES/getPositionDetails', {params:{id:this.id}}).then(res => {
					if (res.code == 200) {
						this.ruleForm={
							position_name: res.data.position_name,
							type: res.data.type,
							position_type_id: res.data.position_type_id,
							part_time_job_type: res.data.part_time_job_type,
							salary_part_time_job: res.data.salary_part_time_job,
							tag_name_year: res.data.tag_name_year,
							tag_name_qualifications: res.data.tag_name_qualifications,
							tag_name_others: res.data.tag_name_others?res.data.tag_name_others.split(','):'',
							salary_type: res.data.salary_type,
							salary_min: res.data.salary_min/1000,
							salary_max: res.data.salary_max/1000,
							position_welfare_policy: res.data.position_welfare_policy,
							work_time: res.data.work_time,
							job_responsibilities: res.data.job_responsibilities,
							position_requirement: res.data.position_requirement,
							position_description: res.data.position_description,
							address: res.data.address,//res.data.address
							address_code: res.data.address_code,
							lng: res.data.lng,
							lat: res.data.lat,
							industry_id: res.data.industry_id,
							address_details:res.data.address_details,
						}
						if(res.data.lat){
							this.location = {
								name:res.data.address+res.data.address_details,
								lat:parseFloat(res.data.lat),
								lng:parseFloat(res.data.lng),
							}
						}
						this.status=res.data.status
						this.loading = false
					} else {
						this.loading = false
						this.$eltips(res.msg, 'error')
					}
				})
			},
			// 保存
			save(type){
				this.$refs['ruleForm'].validate((valid) => {
					if(!valid) return;
					let data=this.ruleForm
					data.tag_name_others=data.tag_name_others.join()
					data.salary_min=data.salary_min*1000
					data.salary_max=data.salary_max*1000
					if(this.id){
						data.position_id=this.id
					}
					let url='/api/client/ES/createPosition'
					if(this.status=='0'||this.status=='1'){
						data.id=this.id
						url='/api/client/ES/editPositionApplys'
					}else{
						data.submit_type=type
					}
					this.loading = true
					this.$axios.post(url, data).then(res => {
						if (res.code == 200) {
							this.loading = false
							this.$eltips('提交成功')
							this.$router.go(-1)
						} else {
							this.loading = false
							this.$eltips(res.msg, 'error')
						}
					})
				});
			},
			remove(){
				this.$confirm('确认删除该职位?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.loading = true
					this.$axios.post('/api/client/ES/deletePosition', {id:this.id}).then(res => {
						if (res.code == 200) {
							this.loading = false
							this.$eltips('删除成功')
							this.$router.go(-1)
						} else {
							this.loading = false
							this.$eltips(res.msg, 'error')
						}
					})
				}).catch(() => {});
			}
		}
	}
</script>

<style lang="scss" scoped>
	#bai-du-map {
		overflow: hidden;
		width: 800px;
		height: 400px;
		margin: 0;
		font-family: "微软雅黑";
	}

	.postJob {
		position: relative;
		padding: 24px 0;
		min-height: 801px;
		box-sizing: border-box;
		.postJobCon {
			width: 1200px;
			margin: 0 auto;
			position: relative;
			z-index: 2;

			.head {
				padding: 28px 38px;
				background-color: #FFF;
				border-radius: 16px;
				margin-bottom: 24px;

				.title {
					color: #151515;
					font-size: 28px;
					font-weight: bold;
				}
				.tips{
					font-size: 15px;
					margin-top: 8px;
					color: #666;
				}
			}

			.fill {
				padding: 33px 43px 38px;
				background-color: #fff;
				border-radius: 16px;

				.title {
					display: flex;
					align-items: center;
					color: #151515;
					font-size: 22px;
					font-weight: bold;
					margin-bottom: 35px;

					.icon {
						width: 39px;
						height: 39px;
						margin-right: 13px;
					}
				}

				.form {
					.el-form-item {
						margin-right: 48px;
					}
					.flexbox{
						display: flex;
						// justify-content: space-between;
					}
					.elInput{
						margin-bottom: 10px;
						.input{
							-webkit-appearance: none;
							background-color: #FFF;
							background-image: none;
							border-radius: 4px;
							border: 1px solid #DCDFE6;
							box-sizing: border-box;
							color: #606266;
							display: inline-block;
							height: 40px;
							line-height: 40px;
							outline: 0;
							padding: 0 15px;
							transition: border-color .2s cubic-bezier(.645,.045,.355,1);
							width: 100%;
						}
					}
					.label, .tags {
						display: flex;
						align-items: center;
						flex-wrap: wrap;

						// width: 343px;
						.tagsLi {
							margin-right: 10px;
							margin-bottom: 10px;
						}
					}

					.tags {
						margin-top: 10px;
					}

					.label {
						// justify-content: space-between;
						// margin-bottom: 20px;
					}
				}

				.buttonG {
					display: flex;
					align-items: center;
					justify-content: flex-end;
					margin-top: 48px;
					.el-button {
						font-size: 16px;
						border-radius: 8px;
						height: 46px;
						padding: 0 28px;
					}
					.save {
						width: 190px;
					}
				}
			}
		}
	}
</style>

<style>
	/* 隐藏高德logo  */
	.amap-logo {
		display: none !important;
	}

	/* 隐藏高德版权  */
	.amap-copyright {
		display: none !important;
	}
</style>